import { type FC, useCallback } from 'react';
import styled from 'styled-components';
import { Icon, IconType } from '../../Props/Icon/Icon';

type SettingsButtonProps = {
  isOpen: boolean;
  setSelectedMenu: (cb: (v: 'user' | 'switchView' | undefined) => 'user' | 'switchView' | undefined) => void;
};

export const SettingsButton: FC<SettingsButtonProps> = ({ isOpen, setSelectedMenu }: SettingsButtonProps) => {
  const clickHandler = useCallback(() => {
    setSelectedMenu((v) => (v === 'user' ? undefined : 'user'));
  }, [setSelectedMenu]);

  return (
    <SettingsContainer isOpen={isOpen} onClick={clickHandler}>
      <Icon className="settings-wheel" width={20} height={20} icon={IconType.SETTINGS_WHEEL} />
    </SettingsContainer>
  );
};

const SettingsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>`
  height: 38px;
  width: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 999px;
  background: ${({ theme, isOpen }) => (isOpen ? theme.colors.topBarHoverBackground : theme.colors.panelBackground)};
  transition:
    background-color 180ms ease,
    border-color 180ms ease;

  svg {
    color: ${({ theme }) => theme.colors.mutedForeground};
  }

  &:hover {
    background: ${({ theme }) => theme.colors.topBarHoverBackground};
    border-color: ${({ theme }) => theme.colors.topBarBorder};
  }

  .settings-wheel {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'none')};
    transition: transform 300ms ease-in-out;
  }
`;
